// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage"; // 👈 NOVO


// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBgFxJjveDoU0_Ze2JpgBSsQSqfh7n6XH0",
  authDomain: "promocoes-8a603.firebaseapp.com",
  projectId: "promocoes-8a603",
  storageBucket: "promocoes-8a603.firebasestorage.app",
  messagingSenderId: "436068135350",
  appId: "1:436068135350:web:386ac18bba2b6a2d00d117"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app); // 👈 EXPORTA O STORAGE

